"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContainer = exports.ModalBox = exports.ContentContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var ModalContainer = exports.ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "Modalstyled__ModalContainer",
  componentId: "sc-hiwnav-0"
})(["height:100%;width:100%;position:absolute;top:0;left:0;z-index:900;background:", "4D;display:flex;justify-content:center;align-items:center;"], _styles.colors.background.layover);
var getSize = function getSize(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'xxl':
      return '1200px';
    case 'xl':
      return '710px';
    case 'l':
      return '640px';
    case 'm':
      return '540px';
    default:
      return '440px';
  }
};
var ModalBox = exports.ModalBox = _styledComponents.default.div.withConfig({
  displayName: "Modalstyled__ModalBox",
  componentId: "sc-hiwnav-1"
})(["box-sizing:border-box;display:flex;justify-content:space-between;width:", ";flex-direction:column;gap:", ";border-radius:", ";background-color:", ";", " padding:", " ", " ", " ", ";"], getSize, _styles.spacing.m, _styles.borderRadius.l, _styles.colors.background.primary, _styles.shadow.xl, _styles.spacing.l, _styles.spacing.l, _styles.spacing.l, _styles.spacing.l);
var ContentContainer = exports.ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "Modalstyled__ContentContainer",
  componentId: "sc-hiwnav-2"
})(["display:flex;flex-direction:column;gap:", ";flex:1;align-items:", ";padding-bottom:", ";"], _styles.spacing.m, function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems;
}, _styles.spacing.xs);